		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PickupDeliveryExtraFeeService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('PickupDeliveryExtraFee');
	}
	
	loadAll() : Observable<TooBig4Car.Logic.PickupDeliveryExtraFee[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: TooBig4Car.Logic.PickupDeliveryExtraFee) : Observable<TooBig4Car.Logic.PickupDeliveryExtraFee> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.PickupDeliveryExtraFee> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.PickupDeliveryExtraFee>{
		return this.myBaseService.get(id, this.url);
	}
	getOrderFees(pickupDeliveryID: System.Guid): Observable<TooBig4Car.Logic.CustomerTypeStorageFeeVM[]> {
		return this.myBaseService.loadAll(this.url + '/OrderFees/' + pickupDeliveryID);
	}
	getAccountOrderFees(customerAccountID: System.Guid): Observable<TooBig4Car.Logic.CustomerTypeStorageFeeVM[]> {
		return this.myBaseService.loadAll(this.url + '/OrderFees/Account/' + customerAccountID);
	}
	saveOrderFee(tempItem: TooBig4Car.Logic.PickupDeliveryOrderFeeVM): Observable<TooBig4Car.Logic.PickupDeliveryExtraFee> {
		return this.myBaseService.post(tempItem, this.url + '/OrderFee', true);
	}
	search(searchTerm: string) : Observable<TooBig4Car.Logic.PickupDeliveryExtraFee[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}
				
